import {
    Button, CircularProgress, Grid, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, Typography
} from "@mui/material";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import MainCard from "ui-component/cards/MainCard";
import {
    IconEdit,
    IconListCheck,
    IconUsersGroup,
    // IconUsersGroup,
} from "@tabler/icons-react";
import { useTheme } from "@mui/system";
import SubCard from "ui-component/cards/SubCard";
import { useParams } from "react-router-dom";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";
import EditState from "./edit";
import Chip from "ui-component/extended/Chip";
import {
    clearStateDetails,
    closeStateEditDialog,
    getStateDetails,
    openStateEditDialog,
    stateDetailsErrorClear
} from "store/app/form-management/state-configuration/actions";
import moment from "moment";

const StateDetails = (props) => {
    //-------------------------State Details Tab------------------------
    const { setCurrentState } = props;
    //-------------------------State Details----------------------------
    const { stateDetails, errorMessage, isPending } = props;
    const { stateName, regionName, isActive, createdBy, createdTimeStamp, updatedBy, updatedTimeStamp } = stateDetails || {};
    const { userLst, adminLst } = stateDetails || [];
    //-------------------------State Edit-------------------------------
    const { isStateEditDialogOpen } = props;
    //-------------------------Profile----------------------------------
    const { userProfile } = props;
    const { userRoleName } = userProfile || {};

    const params = useParams();
    const { id } = params || {};

    useEffect(() => {
        props.getStateDetails(id);
        props.stateDetailsErrorClear();
    }, [id]);

    useEffect(() => {
        if (stateDetails) {
            setCurrentState({ id: id, name: stateName, status: isActive });
        }
    }, [stateDetails])

    const theme = useTheme();

    //-------------------------State Edit-------------------------------
    const handleStateEditOpen = () => {
        props.openStateEditDialog();
    }

    const handleStateEditClose = () => {
        props.closeStateEditDialog();
    }

    return (
        <>
            <Grid container>
                <Grid item md={12}>
                    <SubCard sx={{ p: 1.5, pl: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h4">State/Export Details</Typography>
                        {(!errorMessage && (userRoleName === "Administrator" || userRoleName === "Master admin")) &&
                            <Button
                                variant="contained"
                                size="small"
                                onClick={handleStateEditOpen}
                                startIcon={<IconEdit />}
                            >
                                Edit State/Export
                            </Button>
                        }
                    </SubCard>
                </Grid>
                {errorMessage &&
                    <Grid item md={12} sx={{ mt: 1, mb: 0 }}>
                        <ErrorAlert content={errorMessage} />
                    </Grid>
                }
            </Grid>
            {isPending ?
                <Grid container alignItems={"center"} justifyContent={"center"} gap={1}>
                    <CircularProgress />
                    <Typography variant="h5" color={'primary'}> Loading...</Typography>
                </Grid>
                :
                <Grid container columnSpacing="16">
                    <Grid item md={6}>
                        <MainCard sx={{ mt: 1 }}>
                            <Grid container gap={1} sx={{ display: 'flex', alignItems: 'center' }}>
                                <IconListCheck color={theme.palette.secondary.dark} />
                                <Typography variant="h4" color={theme.palette.primary.dark}>
                                    Basic Info
                                </Typography>
                            </Grid>
                            <TableContainer sx={{ pl: 3, mt: 1, mb: 1 }}>
                                <Table size="small">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>State/Export Name</TableCell>
                                            <TableCell>{stateName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Region Name</TableCell>
                                            <TableCell>{regionName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Active Status</TableCell>
                                            <TableCell>
                                                {isActive ?
                                                    <Chip label={"Active"} chipcolor="success" size="small" />
                                                    : <Chip label={"Inactive"} chipcolor="error" size="small" />
                                                }
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Created By</TableCell>
                                            <TableCell>{createdBy || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Created On</TableCell>
                                            <TableCell>{createdTimeStamp ? moment(createdTimeStamp).format("DD MMM YYYY") : "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Updated By</TableCell>
                                            <TableCell>{updatedBy || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Updated On</TableCell>
                                            <TableCell>{updatedTimeStamp ? moment(updatedTimeStamp).format("DD MMM YYYY") : "N/A"}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </MainCard>
                    </Grid>
                    <Grid item md={6}>
                        <MainCard sx={{ mt: 1 }}>
                            <Grid container alignItems={'center'} gap={1}>
                                <IconUsersGroup color={theme.palette.secondary.dark} />
                                <Typography variant="h4" color={theme.palette.primary.dark}>
                                    Assigned  Users Info
                                </Typography>
                            </Grid>
                            {userLst?.length > 0 ?
                                <TableContainer sx={{ pl: 3, mt: 1, mb: 1 }}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>User Name</TableCell>
                                                <TableCell>Email Address</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {userLst?.map((user, idx) => (
                                                <TableRow key={idx}>
                                                    <TableCell>{user.userName}</TableCell>
                                                    <TableCell>{user.userEmail}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                : <Grid container>
                                    <Typography variant="caption" sx={{ fontSize: "13px", marginTop: "10px" }}>
                                        No user assigned to this state/export.
                                    </Typography>
                                </Grid>
                            }
                        </MainCard>
                    </Grid>
                    <Grid item md={6}>
                        <MainCard sx={{ mt: 1 }}>
                            <Grid container alignItems={'center'} gap={1}>
                                <IconUsersGroup color={theme.palette.secondary.dark} />
                                <Typography variant="h4" color={theme.palette.primary.dark}>
                                    Assigned  Admins Info
                                </Typography>
                            </Grid>
                            {adminLst?.length > 0 ?
                                <TableContainer sx={{ pl: 3, mt: 1, mb: 1 }}>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>User Name</TableCell>
                                                <TableCell>Email Address</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {adminLst?.map((user, idx) => (
                                                <TableRow key={idx}>
                                                    <TableCell>{user.userName}</TableCell>
                                                    <TableCell>{user.userEmail}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                : <Grid container>
                                    <Typography variant="caption" sx={{ fontSize: "13px", marginTop: "10px" }}>
                                        No user assigned to this state/export.
                                    </Typography>
                                </Grid>
                            }
                        </MainCard>
                    </Grid>
                </Grid >
            }

            <EditState
                open={isStateEditDialogOpen}
                userDetails={stateDetails}
                onClose={handleStateEditClose}
            />
        </>
    )
}

const mapStateToProps = (state) => ({
    //-------------------------State Details----------------------------
    stateDetails: state.states.stateDetails,
    isPending: state.states.isStateDetailsPending,
    errorMessage: state.states.stateDetailsErrorMessage,
    //-------------------------State Edit-------------------------------
    isStateEditDialogOpen: state.states.isStateEditDialogOpen,
    //--------------------Profile-----------------------------------
    userProfile: state.login.userProfile,
})

const mapDispatchToProps = (dispatch) => ({
    //-------------------------State Details----------------------------
    getStateDetails: (id) => dispatch(getStateDetails(id)),
    clearStateDetails: () => dispatch(clearStateDetails()),
    stateDetailsErrorClear: () => dispatch(stateDetailsErrorClear()),
    //-------------------------State Edit-------------------------------
    openStateEditDialog: () => dispatch(openStateEditDialog()),
    closeStateEditDialog: () => dispatch(closeStateEditDialog()),
})

export default connect(mapStateToProps, mapDispatchToProps)(StateDetails);